import { Row, Spacing } from "../helpers/layout";
import { css } from "styled-components";
import { PlainButton } from "../components/PlainButton";
import ArrowLeft from "../icons/ArrowLeft";
import ArrowRight from "../icons/ArrowRight";
import { useResponsive } from "../context/ResponsiveContext";
import Router from "next/router";
import { Post } from "../types/Post";
import { Wrapper } from "./Wrapper";

export function PostNavigation(props: { post: Post }) {
  const { post } = props;
  const { isMobile } = useResponsive();

  return (
    <div
      css={css`
        padding: ${Spacing.xl} 0;
      `}
    >
      <Wrapper>
        <Row justify="space-between">
          <Row>
            <PlainButton
              onClick={() => {
                Router.push("/blog");
              }}
              iconPosition="left"
              icon={<ArrowLeft />}
            >
              Return to All Posts
            </PlainButton>
          </Row>
          <div
            css={css`
              svg {
                height: 13px;
              }
            `}
          >
            <Row justify="space-between" gutter={Spacing.xl}>
              <PlainButton
                disabled={!post.previous}
                onClick={() => {
                  Router.push("/blog/[slug]", `/blog/${post.previous!.slug}`);
                }}
                iconPosition="left"
                icon={<ArrowLeft />}
              >
                {isMobile ? "" : "Previous"}
              </PlainButton>
              <PlainButton
                disabled={!post.next}
                onClick={() => {
                  Router.push("/blog/[slug]", `/blog/${post.next!.slug}`);
                }}
                iconPosition="right"
                icon={<ArrowRight />}
              >
                {isMobile ? "" : "Next"}
              </PlainButton>
            </Row>
          </div>
        </Row>
      </Wrapper>
    </div>
  );
}
